/* fullpage */

let fp, fullpage_api;

const menuToggle 	= document.getElementById('menuToggle');
const fpHome 		= document.getElementById('fpHome');
const fpService 	= document.getElementById('fpService');

const init = function() {

	"use strict";

	document.documentElement.classList.add('loaded');

	if ( menuToggle ) {
		menuToggle.addEventListener('click', function(event) {
			this.blur();
			document.documentElement.classList.toggle('active_nav');
			event.preventDefault();
		});
		// Ensure that it works if triggered before the JS loads
		if (window.location.hash && window.location.hash === '#menuTray') {
			document.documentElement.classList.add('active_nav');
		}
	}

	if ( fpHome ) {
		fp = new fullpage('#fpHome', {
			licenseKey: '32F7CC03-E2324A3C-800693A5-5F4682F9',
			sectionSelector: '.wp-block-lazyblock-slide',
			autoScrolling: true,
			scrollingSpeed: 700,
			afterLoad: function(){
				var current = fullpage_api.getActiveSection();
				var btn = current.item.getElementsByClassName('slide-advance');
				if ( btn[0] ) {
					if ( current.isLast == true ) {
						btn[0].addEventListener('click', function(e){
							e.preventDefault();
							fullpage_api.moveTo(1);
						});
					} else {
						btn[0].addEventListener('click', function(e){
							e.preventDefault();
							fullpage_api.moveSectionDown();
						});
					}
				}
			}
		});
	}

	if ( fpService ) {
		fp = new fullpage('#fpService', {
			licenseKey: '32F7CC03-E2324A3C-800693A5-5F4682F9',
			sectionSelector: '.section',
			scrollOverflow: true,
			keyboardScrolling: true,
			bigSectionsDestination: 'top',
			afterRender: function(){
				serviceLinks();
				if ( document.getElementById('serviceAdvance') ) {
					document.getElementById('serviceAdvance').addEventListener('click', function(e){
						e.preventDefault();
						fullpage_api.moveSectionDown();
					});
				}
			},
			afterLoad: function(){
				let current = fullpage_api.getActiveSection();
				if ( current.isFirst == true ) {
					document.documentElement.classList.remove('services-internal');
				} else {
					document.documentElement.classList.add('services-internal');
				}
			}
		});
	}

	let submenuLinks = document.querySelectorAll('.menu-item-has-children a[href="#"]');
	if ( submenuLinks.length > 0 ) {
		submenuLinks.forEach(function(el){
			el.addEventListener('click', function(e){
				e.preventDefault();
				this.classList.toggle('show_submenu');
			});

		});
	}

};

let serviceLinks = function(){
	window.console.log("Running serviceLinks");
	
	// check whether we are on the services page if there is a hash
	if ( document.getElementById('serviceContent') && window.location.hash !== "" && document.getElementById(window.location.hash.substring(1)) !== null ) {

		window.console.log("Found a hash and a section in serviceLinks");

		if ( fullpage && fpService ) {
			fullpage_api.moveTo(2);
		}
		
		let active_services = document.getElementById('serviceContent').querySelectorAll('.active');
		Array.prototype.forEach.call( active_services, function(el) {
			el.classList.remove('active');
		});
		
		document.getElementById(window.location.hash.substring(1)).classList.add('active');
		document.getElementById('servicesNav').classList.add('active');

		let serviceNavs = document.getElementsByClassName('services-link');
		Array.prototype.forEach.call( serviceNavs, function(el) {
			window.console.log(el.href.slice(el.href.lastIndexOf('#') ), window.location.hash, el.href.slice(el.href.lastIndexOf('#') ) == window.location.hash);
			if (el.href.slice(el.href.lastIndexOf('#') ) == window.location.hash) {
				el.classList.add('active');
			}
		});

	}

}


window.addEventListener('load', init, false);
window.addEventListener('popstate', serviceLinks, false);
